const STORAGE_KEY = "warungpay.topup.payment-accounts";

export function getPaymentAccounts() {
    try {
        const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]");
        return Array.isArray(value) ? value : [];
    } catch {
        return [];
    }
}

export function savePaymentAccounts(accounts) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(accounts));
}
